import { ToggleButton, type ToggleButtonProps, Tooltip, type TooltipProps } from '@mui/material';
import React from 'react';

// have to omit the default HTML 'title' prop
interface TooltipToggleButtonProps extends Omit<ToggleButtonProps, 'title'> {
  title?: TooltipProps['title'];
  tooltipProps?: Omit<TooltipProps, 'title' | 'children'>;
}

const TooltipToggleButton: React.FC<TooltipToggleButtonProps> = ({
  title,
  tooltipProps,
  children,
  ...toggleButtonProps
}) => {
  const button = <ToggleButton {...toggleButtonProps}>{children}</ToggleButton>;

  if (title) {
    return (
      <Tooltip title={title} placement="top" {...tooltipProps}>
        {button}
      </Tooltip>
    );
  }

  return button;
};

export default TooltipToggleButton;
